import { useEffect } from "react"

import { useBaseContext } from "contexts/use-base-context"

import { updateTheme } from "utils/update-theme"

const isPreview = window.location.search.includes("isPreview=true")

interface EventData {
  theme?: any
  currency?: string
}

/**
 * Custom hook for managing theme and currency based on event data
 * @param eventData - The event data containing theme and currency information
 * @param isLive - Whether the registration is currently live
 */
export const useThemeAndCurrency = (eventData: EventData | undefined, isLive: boolean | undefined) => {
  const { setCurrencySymbol } = useBaseContext()

  useEffect(() => {
    // Apply theme if event is live and not in preview mode
    if (eventData?.theme && !isPreview && isLive) {
      updateTheme(eventData.theme)
    }
  }, [eventData?.theme, isLive])

  useEffect(() => {
    // Set currency symbol based on event currency
    if (eventData?.currency) {
      const currencySymbol = eventData.currency === "USD" ? "$" : "£"
      setCurrencySymbol(currencySymbol)
    }
  }, [eventData?.currency, setCurrencySymbol])
}